module.exports = __webpack_public_path__ + "media/images/league-1-43544c988c2ad5bf9b76bf9a66168174.png";